import createIcon from '../../createIcon';

/**
 * @component @name RunningWithErrors
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTBWMThIMjBWMTBIMjJaTTIwIDIwVjIySDIyVjIwSDIwWk0xOCAxNy4yOUMxNi41MyAxOC45NSAxNC4zOSAyMCAxMiAyMEM3LjU5IDIwIDQgMTYuNDEgNCAxMkM0IDcuNTkgNy41OSA0IDEyIDRWMTNMMTkuNTUgNS40NUMxNy43MiAzLjM0IDE1LjAyIDIgMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIyQzE0LjI1IDIyIDE2LjMzIDIxLjI2IDE4IDIwVjE3LjI5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RunningWithErrors = createIcon('RunningWithErrors', [
  [
    'path',
    {
      d: 'M22 10V18H20V10H22ZM20 20V22H22V20H20ZM18 17.29C16.53 18.95 14.39 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4V13L19.55 5.45C17.72 3.34 15.02 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C14.25 22 16.33 21.26 18 20V17.29Z',
      key: 'wjrtc9',
    },
  ],
]);

export default RunningWithErrors;
